var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('job-item-content',_vm._g(_vm._b({on:{"search":_vm.searchJob}},'job-item-content',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }